import type { FC } from 'react';

import { DealListPanel } from '@entities/Deal';

export interface MyDealsProps {
  onOpenDeal: (dealId: string) => void;
}

export const MyDeals: FC<MyDealsProps> = ({ onOpenDeal }) => (
  <DealListPanel source="agent_outbound" onOpenDeal={onOpenDeal} />
);

MyDeals.displayName = 'MyDeals';
